const isLocal = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1'
);

const BACKEND_BASE = isLocal
  ? 'http://localhost:3001'
  : 'https://tbl.zerdegroup.kz';

export const API_CONFIG = {
  BASE_URL: `${BACKEND_BASE}/api`,
  AUTH_V2_URL: `${BACKEND_BASE}/api/v2/auth`,
  ROLES_V2_URL: `${BACKEND_BASE}/api/v2/roles`,
  USERS_V2_URL: `${BACKEND_BASE}/api/v2/users`,
  BIOMETRICS_V2_URL: `${BACKEND_BASE}/api/v2/biometrics`,
  TIMEOUT: 8000,
} as const;

export const APP_CONFIG = {
  VERSION: '1.0.8',
  TOKEN_KEY: 'userToken',
  USER_KEY: 'userData',
  REMEMBER_KEY: 'rememberMe',
  SERVER_STATUS_CHECK_INTERVAL: 30000,
  REMEMBER_ME_EXPIRES_DAYS: 1000
} as const;

export const ROUTES = {
  ADMIN: '/admin',
  DASHBOARD: '/dashboard',
} as const;

export const ADMIN_ROLES = ['superadmin', 'admin', 'moder', 'view', 'guide', 'km', 'to', 'full-report'] as const;
